export enum RequestServiceStatus {
	FREE = "free",
	PAID = "paid",
	PAY_PENDING = "pay_pending"
}
